module.exports = __webpack_public_path__ + "static/media/impactIcon2.7e5efe0d.png";